import { render, staticRenderFns } from "./exExpertScoringComIndex.vue?vue&type=template&id=65755ba9&"
import script from "./exExpertScoringComIndex.vue?vue&type=script&lang=js&"
export * from "./exExpertScoringComIndex.vue?vue&type=script&lang=js&"
import style0 from "./exExpertScoringComIndex.vue?vue&type=style&index=0&id=65755ba9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports